// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "monaco" : chunkId) + "." + {"370":"6440edccf7416283","502":"8ffd8a6959c8dd1f"}[chunkId] + ".js";
};